import { DossierObjectGroup } from '@europrocurement/l2d-domain';
import React, { createContext, Dispatch, Reducer, useContext, useReducer } from 'react';

// export type DossierGroupeAction = 'edit' | 'delete' | undefined;

type contexStateDossierGroup = {
    selectedDossierGroupe?: DossierObjectGroup;
    action: string;
    modalOpen: boolean;
};
type ActionProps = {
    type: string;
    payload?: DossierObjectGroup;
};

const initialDossierGroupeAction: contexStateDossierGroup = {
    selectedDossierGroupe: undefined,
    action: '',
    modalOpen: false,
};
const DossierGroupeActionContext = createContext(initialDossierGroupeAction);
const DossierGroupeActionDispatchContext = createContext<Dispatch<ActionProps>>(() => {});

const dossierGroupeActionReducer: Reducer<contexStateDossierGroup, ActionProps> = (
    state: contexStateDossierGroup,
    action: ActionProps,
) => {
    switch (action.type) {
        case 'create': {
            return {
                ...state,
                action: action.type,
                modalOpen: true,
            };
        }

        case 'edit':
        case 'delete': {
            return {
                ...state,
                selectedDossierGroupe: action.payload,
                action: action.type,
                modalOpen: true,
            };
        }

        case 'close_and_reset': {
            return {
                ...state,
                selectedDossierGroupe: undefined,
                action: '',
                modalOpen: false,
            };
        }

        default: {
            throw Error(`Unknown action: ${action.type}`);
        }
    }
};

export const DossierGroupeActionProvider: React.FunctionComponent<React.PropsWithChildren> =
    function ({ children }) {
        const [dossierGroupeAction, dispatch] = useReducer(
            dossierGroupeActionReducer,
            initialDossierGroupeAction,
        );

        return (
            <DossierGroupeActionContext.Provider value={dossierGroupeAction}>
                <DossierGroupeActionDispatchContext.Provider value={dispatch}>
                    {children}
                </DossierGroupeActionDispatchContext.Provider>
            </DossierGroupeActionContext.Provider>
        );
    };

export function useDossierGroupeAction() {
    return useContext(DossierGroupeActionContext);
}

export function useDossierGroupeActionDispatch() {
    return useContext(DossierGroupeActionDispatchContext);
}
